import {
    BackButton,
    BackButtonIconType,
    BodySmallEmphasized,
    Icon,
    Image,
    isNonMobileWeb,
    LabelRegular,
    SearchIcon,
    View,
    XStack,
    YStack,
} from 'smoothie';

import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { getPartnerDisplayFirstName } from '../../common/utils/userUtils';

interface ChatHeaderProps {
    onPressHeaderLeft: () => void;
    onPressHeaderRight: () => void;
}

const ChatHeader = (props: ChatHeaderProps) => {
    const user = useAuthedUser();
    const { membership } = user ?? {};
    const { guide } = membership ?? {};
    const guideDisplayName = guide?.firstName ?? 'Your Guide';
    const partnerDisplayName = getPartnerDisplayFirstName(
        user.partnerMember?.firstName,
    );
    const chatTitle = user.partnerMember
        ? `${guideDisplayName}, ${partnerDisplayName}`
        : guideDisplayName;

    const { onPressHeaderRight, onPressHeaderLeft } = props;

    const imageSize = isNonMobileWeb ? 40 : 32;

    return (
        <XStack
            alignItems="center"
            justifyContent="space-between"
            height={56}
            paddingTop={10}
            paddingBottom={10}
            borderBottomWidth={1}
            paddingHorizontal={8}
            borderBottomColor="$gray300"
            gap={8}
        >
            {!isNonMobileWeb && (
                <BackButton
                    customBackFn={onPressHeaderLeft}
                    iconType={BackButtonIconType.LEFT}
                />
            )}
            <XStack alignItems="center" flexGrow={1}>
                <Image
                    borderRadius={50}
                    source={{
                        width: imageSize,
                        height: imageSize,
                        uri: guide?.profileImageUrl ?? '',
                    }}
                />
                <YStack marginLeft={8}>
                    <BodySmallEmphasized>{chatTitle}</BodySmallEmphasized>
                    <LabelRegular
                        color="$gray1000"
                        marginTop={2}
                        maxWidth={isNonMobileWeb ? 400 : 240}
                    >
                        I&apos;ll get back to you as soon as I can, usually
                        within a day.
                    </LabelRegular>
                </YStack>
            </XStack>
            <View padding={16} onPress={onPressHeaderRight}>
                <Icon icon={SearchIcon} size={16} />
            </View>
        </XStack>
    );
};

export default ChatHeader;
